module.exports = __webpack_public_path__ + "img/worki.6605e5c6.png";